import React from "react";
import DisplayError from "../../../../../common/DisplayError";

const Input = (props) => {
  return (
    <React.Fragment>
      <div className="form-group">
        <label htmlFor={props.name}>{props.label}</label>
        <input
          placeholder={props.placeHolder}
          type={props.type}
          className="form-control"
          {...props.register(props.name, props.validationsObject)}
        />
        <DisplayError
          errorCondition={props.error}
          errorMessage={props.error && props.error.message}
        />
      </div>
    </React.Fragment>
  );
};

export default Input;
